module.exports = __webpack_public_path__ + "img/07_bill_42px_42px_01.42c7907d.png";